import React from 'react';

import { useBiopharmaGroupState, useBiopharmaGroupActions } from './BiopharmaGroupContext';
import { reopenJobDescription } from './restApi';

import Form from '../../Shared/UI/Form/components/Form';
import FormInstruction from '../../Shared/UI/FormInstruction/components/FormInstruction';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

const ReopenJobDescriptionForm = () => {
  const biopharmaGroupState = useBiopharmaGroupState();
  const { onResponse, onError, closeReopenJobDescriptionModal } = useBiopharmaGroupActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const title = biopharmaGroupState?.reopenJobDescription?.title || 'this job description';

  const handleSubmit = () => {
    reopenJobDescription({
      onResponse,
      onError,
      body: {
        authenticityToken,
        reopenJobDescription: biopharmaGroupState?.reopenJobDescription,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <FormInstruction>
        Are you sure you want to reopen <strong>{title}</strong>? It will be included in future match score calculations and job prospect creation.
      </FormInstruction>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => closeReopenJobDescriptionModal()}
          >
            Cancel
          </Button>
          <Button type="submit">
            Reopen Job Description
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default ReopenJobDescriptionForm;
